import { FaCode, FaCloud } from "react-icons/fa";

export const QUICK_FACTS = [
  { icon: "FaMapMarkerAlt", text: "Calgary, Canada" },
  { icon: "FaCode", text: "17+ Years Coding" },
  { icon: "FaUsers", text: "Led 100+ Developers" },
  { icon: "FaRocket", text: "Co-Founder Experience" },
  { icon: "FaLanguage", text: "3 Languages" },
];

export const STATS = [
  { icon: FaCode, label: "Lines of Code", value: "500K+", delay: 0 },
  { icon: FaCode, label: "Web Apps", value: "12+", delay: 0.1 },
  { icon: FaCloud, label: "Cloud Projects", value: "30+", delay: 0.2 },
  { icon: FaCode, label: "Frameworks", value: "10+", delay: 0.3 },
];
